import $ from '../tools/Dom';
import request from '../tools/request';

export default (el, data) => {
    const dom = $(el);
    const endpoint = data.endpoint;
    const minuteWrapper = dom.find('[data-min]');
    const secondWrapper = dom.find('[data-sec]');
    const secondUnits = dom.find('[data-sec-unit]');

    const updateWaitTime = time => {
        console.log('updateWaitTime');
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;

        minuteWrapper.html(minutes);
        if (seconds > 0) {
            secondWrapper.html(seconds);
        } else {
            secondWrapper.remove();
            secondUnits.remove();
        }

        dom.addClass('js-show');
    };

    const getWaitTime = () => {
        request.get(`/actions/eyr/wait-time?endpoint=${endpoint}`).then(res => {
            const responseJson = JSON.parse(res.text);
            updateWaitTime(responseJson.data);
        }, error => {
            console.error(error);
            dom.addClass('js-show');
        });
    };

    const init = () => {
        if (endpoint) {
            getWaitTime();
        }
    };

    const destroy = () => {
    };

    return {
        init,
        destroy
    };
};
